import { render, staticRenderFns } from "./calculator-demo.vue?vue&type=template&id=09c4da9e&scoped=true&"
import script from "./calculator-demo.vue?vue&type=script&lang=ts&"
export * from "./calculator-demo.vue?vue&type=script&lang=ts&"
import style0 from "./calculator-demo.vue?vue&type=style&index=0&id=09c4da9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c4da9e",
  null
  
)

export default component.exports